export default {
      id: "youtube-usage",
      viewBox: "0 0 21.9 15.4",
      url: __webpack_public_path__ + "svg/sprite.svg#youtube",
      toString: function () {
        return this.url;
      }
    }